<template>
  <div class="rounded-xl bg-white shadow-md">
    <div
      class="flex align-center justify-between px-5 md:px-10 py-5 pb-7 flex-row text-center md:text-left items-center"
    >
      <div
        v-if="donorStore.staticTotalDonations == 0"
        class="max-w-[762px]"
        data-test="welcome-message"
      >
        <h1 class="text-4xl font-normal mb-5 block">
          Welcome, <strong class="font-bold">{{ donorStore.donorInfo.firstName }}</strong
          >!
        </h1>
        <p class="mb-3">
          Welcome to our Gives Day Donor Portal! As you make donations, you can check back here for insights and metrics
          on the impact of your generosity.
        </p>
        <p>Thank you for your support!</p>
      </div>

      <div
        v-else
        data-test="summary-message"
      >
        <h1 class="text-4xl font-normal mb-5 block">
          Welcome back, <strong class="font-bold">{{ donorStore.donorInfo.firstName }}</strong
          >!
        </h1>
        <p class="mb-3">
          Since {{ new Date(donorStore.donorInfo.enteredDate).getFullYear() }}, you've made
          <strong>{{ donorStore.staticTotalDonations }}</strong>
          donations totaling
          <strong>{{ filters.formatMoney(donorStore.staticTotalAmountDonated) }}</strong
          >, and your generosity has made an impact for <strong>{{ donorStore.staticTotalCauses }}</strong> causes!
        </p>
        <p>Thank you for your support!</p>
      </div>
      <div
        v-if="!isMobile"
        data-test="heart-box"
      >
        <HeartBox :fill="donorStore.mainColor" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { useDonorStore } from '@/stores/DonorStore.js';
import filters from '@/helpers/filters';
import HeartBox from '@/assets/HeartBox.vue';
import useIsMobile from '@/composables/useIsMobile.js';
const { isMobile } = useIsMobile();

const donorStore = useDonorStore();
</script>
